import { Modal, Box } from '@mui/material';
import React from 'react';

import useModalStyle from '../../../../utils/useModalStyle';

/**A modal created from a stylized Modal and Box MUI component.
 *
 * @param {ReactNode} children A ReactNode to display. Generally something complex like ChangeUsername or BatchStatusUpdate.
 * @param {Object} modalSx A MUI sx Object to apply to the Modal wrapper to override/apply additional styles than the default.
 * @param {Object} boxSx A MUI sx Object to apply to the Box wrapper to override/apply additional styles than the default.
 */
const MuiModal = ({ children, modalSx, boxSx, ...restOfProps }) => {
    const { useStyle } = useModalStyle();
    const styles = useStyle();
    return (
        <Modal
            {...restOfProps}
            sx={(theme) => {
                let override = typeof modalSx === 'function' ? modalSx(theme) : modalSx;
                return {
                    ...override,
                };
            }}
        >
            <Box
                className={styles.modalStyle}
                sx={(theme) => {
                    let override = typeof boxSx === 'function' ? boxSx(theme) : boxSx;
                    return {
                        ...override,
                    };
                }}
            >
                {children}
            </Box>
        </Modal>
    );
};

export default MuiModal;
